(function () {
  'use strict';

  var I18N = (window.ZAGARA && window.ZAGARA.i18n) || {};
  var ROUTES = window.routes || {};
  var LOCALE = (document.documentElement.lang || 'en').toLowerCase();
  var LOCALE_KEY = LOCALE.replace(/[^a-z0-9-]/g, '') || 'en';
  var ROOT_URL = (ROUTES.root || '/').replace(/\/?$/, '/');
  var PRODUCTS_ROOT = ROOT_URL + 'products/';
  var CATALOG_URL = (ROUTES.all_products || '/collections/all').replace(/\/$/, '') + '/products.json';
  var SEARCH_URL = ROUTES.search || '/search';
  var PREDICTIVE_URL = (ROUTES.predictive_search || '/search/suggest').replace(/\.json$/, '') + '.json';

  /* Giro finale, parte 1.4 (08/10/2026): i suggerimenti predittivi di Shopify
     (/search/suggest: pagine, ricette e, in inglese, le domande) solo nelle
     lingue che Shopify supporta. L'elenco e' quello della documentazione
     ufficiale (shopify.dev, «Predictive Search API reference», letta
     l'08/10/2026), per sottotag di lingua: arabo, giapponese, coreano e cinese
     non ci sono, e li' Shopify risponde 417 «Unsupported buyer locale», che il
     browser scrive in console da solo. Il segnale previsto
     (shopify-features.predictiveSearch) su questo negozio dice true anche in
     ar, ja, ko e zh-TW: conta solo quando dice false. In una lingua fuori
     elenco il tema non chiama il predittivo: il pannello mostra i prodotti
     dell'indice locale, e pagine e ricette si cercano con la ricerca completa
     (Enter o il link «tutti i risultati» in fondo al pannello), che resta in
     tutte le lingue e chiede tutti e tre i tipi (FULL_SEARCH_TYPES, qui
     sotto). Senza JS non c'e' ricerca: il pannello ha hidden e lo apre solo
     open(), e i due bottoni della testata non hanno href (un limite di prima;
     il form GET di theme.liquid porta gli stessi tre tipi in un campo
     nascosto, per un invio che non passi dall'Enter qui sotto). Un 417 in una lingua
     dell'elenco (Shopify ne toglie una, o un codice qui e' sbagliato) spegne
     il predittivo per la sessione, in quella lingua; un 429 lo mette in pausa
     fino a Retry-After. Le domande suggerite esistono solo in inglese:
     altrove si chiedono pagine e articoli.
     Tappa 1b (critico della tappa 1, basso 22; revisore di p1-ricerca): finche'
     nessun 200 ha confermato la lingua, al predittivo va UNA richiesta per
     volta (predictiveProbe, in searchInfo). Prima, con la rete lenta, ogni
     tasto dopo la pausa di 130 ms ne mandava un'altra, e ogni 417 scriveva la
     sua riga in console (banco: 4 righe a 800 ms con «pistachio» scritto a
     250 ms per tasto). Ora un 417 scrive al massimo una riga per pagina, e
     nessuna dopo, nella stessa sessione. Le ricerche che aspettano la prima
     risposta non mandano niente; quando arriva il 200 parte quella dell'ultima
     parola scritta, le altre si lasciano (non entrano in cache). */
  var PREDICTIVE_LANGS = ['af', 'sq', 'hy', 'bs', 'bg', 'ca', 'hr', 'cs', 'da', 'nl', 'en', 'et', 'fo', 'fi', 'fr', 'gd',
    'de', 'el', 'hu', 'is', 'id', 'it', 'la', 'lv', 'lt', 'mk', 'mo', 'no', 'nb', 'nn', 'pl', 'pt', 'ro', 'ru', 'sr', 'sh',
    'sk', 'sl', 'es', 'sv', 'tr', 'uk', 'vi', 'cy'];
  var LANG = LOCALE.split('-')[0];
  var PREDICTIVE_OFF_KEY = 'zagara_predictive_off_' + LOCALE_KEY;
  var PREDICTIVE_TYPES = LANG === 'en' ? 'query,page,article' : 'page,article';
  var predictiveOn = PREDICTIVE_LANGS.indexOf(LANG) !== -1 && shopifyPredictiveFlag() !== false && !predictiveOffForSession();
  var predictivePauseUntil = 0;
  var predictiveConfirmed = false;
  var predictiveProbe = null;

  /* Giro finale, tappa 1b (critico della tappa 1, media 4; foglio 01 §1.4,
     08/10/2026): la ricerca completa (/search) chiede prodotti, pagine e
     articoli (le ricette). Prima Enter portava a type=product, e in ar, ja, ko
     e zh-TW, dove il predittivo e' spento, pagine e ricette non si potevano
     trovare da nessuna parte. I tipi sono scritti invece di togliere il
     parametro: senza type vale il predefinito, «Defaults to all types», che
     si cambia dalle impostazioni dell'app Search & Discovery (shopify.dev,
     «Storefront search», riga del parametro type: «To change the default
     value, you can use Search Settings in the Search & Discovery app»;
     help.shopify.com, «Search & Discovery settings», «Adjusting search result
     type»; riletti il 09/10/2026). CHE LE RICETTE ESCANO NON E' PROVATO: la
     ricerca servita dalla copia il 07/10 (/search?q=pesto, senza type) dava
     16 prodotti e nessuna delle due ricette con «pesto» nel titolo. Se col
     type scritto escono, la causa era il predefinito; se no, sta nell'indice
     del negozio (misura in anteprima, tappa1b/b-ricerca-404-correzioni.md).
     La pagina dei risultati (main-search.liquid) mette i prodotti nella
     griglia e pagine e ricette nel blocco «Pages, FAQs & guides». */
  var FULL_SEARCH_TYPES = 'product,page,article';

  function shopifyPredictiveFlag() {
    try {
      var el = document.getElementById('shopify-features');
      var data = el ? JSON.parse(el.textContent) : null;
      return data && typeof data.predictiveSearch === 'boolean' ? data.predictiveSearch : null;
    } catch (e) {
      return null;
    }
  }

  function predictiveOffForSession() {
    try {
      return sessionStorage.getItem(PREDICTIVE_OFF_KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  // Locale-scoped caches prevent an English catalog from leaking into an
  // Italian/Arabic search session after the customer changes language.
  var STORAGE_KEY = 'zagara_search_v2_' + LOCALE_KEY;
  // v7 (02/09): l'indice in cache porta gia titolo spezzato e titleText sul
  // titolo intero; senza il salto di versione un visitatore di ritorno
  // terrebbe i nomi vecchi finche la cache non scade.
  // Una versione sola per indice E risultati (02/09, 8c): i suggerimenti
  // passano dalla cache dei risultati, e quella chiave non era versionata —
  // sulla stessa origine il tema live e la bozza se la passavano. v9 perche
  // cambia la costruzione dei suggerimenti; ogni cambio a indice, punteggio o
  // suggerimenti alza QUESTO numero e basta.
  var CATALOG_VERSION = 'v9';
  var CATALOG_KEY = 'zagara_selection_catalog_' + CATALOG_VERSION + '_' + LOCALE_KEY;
  var RESULT_CACHE_PREFIX = 'zagara_selection_results_v5_' + CATALOG_VERSION + '_' + LOCALE_KEY + '_';
  var CACHE_TTL = 10 * 60 * 1000;
  var RECENT_TTL = 90 * 24 * 3600000;
  var MAX_RECENT = 10;
  var DEBOUNCE_MS = 130;
  var PAGE_LIMIT = 250;

  var CATEGORY_LABELS = I18N.searchCategories || {
    'gift-boxes': 'Gift boxes',
    'olive-oil': 'Olive oil',
    'pistachio-almond': 'Pistachio & almond',
    'biscuits-sweets': 'Biscuits & sweets',
    'conserves-sauces': 'Conserves & sauces',
    'sicilian-drinks': 'Sicilian drinks',
    'pantry-staples': 'Pantry staples'
  };
  var CATEGORY_TERMS = Object.keys(CATEGORY_LABELS).map(function (key) { return CATEGORY_LABELS[key]; });

  /* Nome e sottotitolo: la funzione vive in luxury.js (window.ZAGARA.splitTitle,
     unica copia JS, specchio del Liquid). Guardia: se non c'e, si stampa il
     titolo intero — mai una riga vuota. */
  function splitTitle(full) {
    var fn = window.ZAGARA && window.ZAGARA.splitTitle;
    if (typeof fn === 'function') return fn(full);
    return { name: String(full || '').trim(), sub: '' };
  }

  var isOpen = false;
  var currentQuery = '';
  var recentSearches = [];
  var trendingProducts = [];
  var catalogProducts = [];
  var catalogPromise = null;
  var debounceTimer = null;
  var loadingTimer = null;
  var prefetchTimer = null;
  var focusedIdx = -1;

  function esc(s) {
    return String(s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function t(key, fallback) {
    return I18N[key] || fallback;
  }

  // The header renders its controls once per breakpoint branch (desktop and
  // mobile markup): writes go to every instance, reads use the visible one.
  function searchToggles() { return document.querySelectorAll('[data-role="search-toggle"]'); }
  function visibleSearchToggle() {
    var list = searchToggles();
    for (var i = 0; i < list.length; i++) { if (list[i].offsetParent !== null) return list[i]; }
    return list[0] || null;
  }

  function handleize(s) {
    return String(s || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function normalizeText(s) {
    return String(s || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function formatMoney(cents) {
    // Shared formatter (luxury.js) handles all Shopify amount placeholders.
    if (window.zagaraFormatMoney) return window.zagaraFormatMoney(cents);
    var fmt = window.moneyFormat || '${{amount}}';
    return fmt.replace(/\{\{amount[^}]*\}\}/, (cents / 100).toFixed(2));
  }

  function priceToCents(value) {
    if (typeof value === 'number') return Math.round(value * 100);
    var parsed = parseFloat(String(value || '').replace(/[^0-9.]/g, ''));
    return Number.isFinite(parsed) ? Math.round(parsed * 100) : 0;
  }

  function productIsAvailable(product) {
    return (product.variants || []).some(function (variant) { return variant && variant.available === true; });
  }

  // Gli aiuti del costruttore di regali non sono prodotti da cercare: sono i
  // pezzi con cui il costruttore monta una cassetta. La regola e' il TIPO, come
  // gia' fa la pagina dei risultati (main-search.liquid), non l'handle: cosi'
  // vale anche per l'aiuto che nascera' domani con un altro nome. Le stringhe
  // restano sotto come rete, perche' un tipo scritto male in admin non deve
  // rimettere «Gift Letter» davanti ai cofanetti veri (17/09/2026).
  var TIPI_ESCLUSI = ['gift-builder-helper'];
  function productIsExcluded(product) {
    var tipo = handleize(product.product_type || product.type || '');
    if (TIPI_ESCLUSI.indexOf(tipo) !== -1) return true;
    var tags = product.tags || [];
    if (typeof tags === 'string') tags = tags.split(',');
    for (var i = 0; i < tags.length; i++) {
      if (handleize(tags[i]) === 'hidden-helper') return true;
    }
    var handle = handleize(product.handle);
    var title = handleize(product.title);
    return handle.indexOf('gift-letter') !== -1 ||
      title === 'gift-letter' ||
      handle.indexOf('sicilian-gift-box') !== -1 ||
      title.indexOf('sicilian-gift-box') !== -1 ||
      handle.indexOf('sicilian-table-box') !== -1 ||
      title.indexOf('sicilian-table-box') !== -1;
  }

  function selectionCategory(product, vendorHandle, words) {
    if (words.indexOf('gift-box') !== -1 || words.indexOf('cassetta') !== -1 || words.indexOf('sicilian-table-box') !== -1 || words.indexOf('ready-made-gift-box') !== -1 || words.indexOf('gift-container') !== -1) {
      return 'gift-boxes';
    }
    if (vendorHandle === 'romano-vincenzo' || vendorHandle === 'romano' || vendorHandle === 'vincenzo-romano' || vendorHandle === 'romano-vincenzo-dal-1959') {
      return 'olive-oil';
    }
    if (vendorHandle === 'evergreen' || vendorHandle === 'evergreen-sicily') {
      if (words.indexOf('crema-pistacchio') !== -1 || words.indexOf('pistachio-cream') !== -1 || words.indexOf('pistachio-spread') !== -1) {
        return 'pistachio-almond,biscuits-sweets';
      }
      return 'pistachio-almond';
    }
    if (vendorHandle === 'tumminello' || vendorHandle === 'biscotti-tumminello' || vendorHandle === 'tumminello-biscotti' || vendorHandle === 'arca' || vendorHandle === 'arca-by-biscotti-tumminello' || vendorHandle === 'duci-siculi' || vendorHandle === 'cosi-chini' || vendorHandle === 'frolle-ripiene') {
      if (words.indexOf('almond') !== -1 || words.indexOf('mandorle') !== -1 || words.indexOf('mandorla') !== -1 || words.indexOf('manna') !== -1 || words.indexOf('latta-autore') !== -1 || words.indexOf('gift-tin') !== -1 || words.indexOf('biscuit-tin') !== -1) {
        return 'pistachio-almond,biscuits-sweets';
      }
      return 'biscuits-sweets';
    }
    if (vendorHandle === 'sicula-briosce' || vendorHandle === 'siculabriosce' || vendorHandle === 'sicula-brioche' || vendorHandle === 'sicula') {
      return 'biscuits-sweets,pantry-staples';
    }
    if (vendorHandle === 'rosso-di-sicilia' || vendorHandle === 'rosso-sicilia' || vendorHandle === 'rossodisicilia') {
      if (words.indexOf('brusche') !== -1) return 'conserves-sauces,pantry-staples';
      return 'conserves-sauces';
    }
    if (vendorHandle === 'polara' || vendorHandle === 'polara-aranciata' || vendorHandle === 'polara-beverage') {
      return 'sicilian-drinks';
    }
    return 'pantry-staples';
  }

  function categoryLabel(category) {
    var parts = String(category || '').split(',');
    return parts.map(function (part) { return CATEGORY_LABELS[part] || part; }).filter(Boolean).join(' / ');
  }

  function normalizedProduct(product) {
    var vendorHandle = handleize(product.vendor);
    var type = product.product_type || product.type || '';
    var words = handleize([product.handle, product.title, type].join(' '));
    var category = selectionCategory(product, vendorHandle, words);
    var displayVendor = product.vendor || '';
    var filterVendor = vendorHandle;
    if (vendorHandle === 'zagara-selection' || vendorHandle === 'zagara-luxury' || vendorHandle === 'zagara-store' || category.indexOf('gift-boxes') !== -1) {
      filterVendor = 'zagara';
      if (vendorHandle === 'zagara-selection' || vendorHandle === 'zagara-luxury' || vendorHandle === 'zagara-store') displayVendor = 'ZAGARA';
    }
    var variants = product.variants || [];
    var firstAvailable = variants.find(function (variant) { return variant && variant.available === true; }) || variants[0] || {};
    var priceCents = priceToCents(firstAvailable.price || product.price || product.price_min);
    var image = product.images && product.images[0] && product.images[0].src ? product.images[0].src : '';
    var tags = Array.isArray(product.tags) ? product.tags.join(' ') : String(product.tags || '');
    // Il nome mostrato e la prima parte dello spezzamento, in ogni lingua,
    // come sulla card Liquid; la seconda parte va sotto il nome nelle tile.
    var parts = splitTitle(product.title || '');
    var title = parts.name;
    var subtitle = parts.sub;
    var available = productIsAvailable(product);
    var searchText = normalizeText([
      title,
      product.title,
      product.handle,
      displayVendor,
      product.vendor,
      type,
      categoryLabel(category),
      category,
      tags,
      variants.map(function (variant) { return [variant.title, variant.sku].join(' '); }).join(' ')
    ].join(' '));

    return {
      id: product.id,
      handle: product.handle,
      title: title,
      rawTitle: product.title || title,
      subtitle: subtitle,
      vendor: displayVendor,
      vendorHandle: filterVendor,
      productType: type,
      category: category,
      categoryLabel: categoryLabel(category),
      url: PRODUCTS_ROOT + encodeURIComponent(product.handle),
      image: image,
      priceCents: priceCents,
      price: priceCents ? formatMoney(priceCents) : '',
      available: available,
      availabilityLabel: available ? (I18N.inStock || 'In stock') : (I18N.notifyMe || 'Notify me'),
      searchText: searchText,
      titleText: normalizeText(product.title || title),
      // C-bis (02/09): il bonus di prefisso guarda il nome mostrato O il
      // sottotitolo; titleText resta il titolo intero per il +70 di contenuto.
      nameText: normalizeText(title),
      subText: normalizeText(subtitle),
      handleText: normalizeText(product.handle),
      vendorText: normalizeText(displayVendor),
      categoryText: normalizeText(category + ' ' + categoryLabel(category))
    };
  }

  function readCatalogCache() {
    try {
      var raw = sessionStorage.getItem(CATALOG_KEY);
      if (!raw) return null;
      var cached = JSON.parse(raw);
      if (Date.now() - cached.ts > CACHE_TTL) {
        sessionStorage.removeItem(CATALOG_KEY);
        return null;
      }
      return Array.isArray(cached.products) ? cached.products : null;
    } catch (e) {
      return null;
    }
  }

  function writeCatalogCache(products) {
    try {
      sessionStorage.setItem(CATALOG_KEY, JSON.stringify({ ts: Date.now(), products: products }));
    } catch (e) {}
  }

  function fetchCatalogPage(page, acc) {
    return fetch(CATALOG_URL + '?limit=' + PAGE_LIMIT + '&page=' + page, { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('catalog');
        return response.json();
      })
      .then(function (data) {
        var products = data.products || [];
        acc = acc.concat(products);
        if (products.length === PAGE_LIMIT && page < 10) return fetchCatalogPage(page + 1, acc);
        return acc;
      });
  }

  function loadCatalog() {
    if (catalogProducts.length) return Promise.resolve(catalogProducts);
    if (catalogPromise) return catalogPromise;

    var cached = readCatalogCache();
    if (cached) {
      catalogProducts = cached;
      trendingProducts = cached.slice(0, 6);
      return Promise.resolve(cached);
    }

    catalogPromise = fetchCatalogPage(1, [])
      .then(function (products) {
        catalogProducts = products
          .filter(function (product) { return product && !productIsExcluded(product); })
          .map(normalizedProduct);
        trendingProducts = catalogProducts.slice(0, 6);
        writeCatalogCache(catalogProducts);
        return catalogProducts;
      })
      .catch(function () {
        // Reset the cached promise so a transient failure (network blip,
        // throttle) retries on the next query instead of leaving search
        // empty for the rest of the page lifetime.
        catalogPromise = null;
        catalogProducts = [];
        return catalogProducts;
      });

    return catalogPromise;
  }

  function loadRecent() {
    try {
      var data = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
      var cutoff = Date.now() - RECENT_TTL;
      recentSearches = (data.recentSearches || []).filter(function (item) { return item.ts > cutoff; });
    } catch (e) {
      recentSearches = [];
    }
  }

  function saveRecent() {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({ recentSearches: recentSearches.slice(0, MAX_RECENT) }));
      localStorage.setItem('zagara_search_ts', String(Date.now()));
    } catch (e) {}
  }

  function addToRecent(q) {
    q = q.trim();
    if (!q) return;
    recentSearches = recentSearches.filter(function (item) { return item.q !== q; });
    recentSearches.unshift({ q: q, ts: Date.now() });
    recentSearches = recentSearches.slice(0, MAX_RECENT);
    saveRecent();
  }

  function removeFromRecent(q) {
    recentSearches = recentSearches.filter(function (item) { return item.q !== q; });
    saveRecent();
  }

  function resultsUrl(q) {
    q = (q || '').trim();
    var wildcard = q.split(/\s+/).filter(Boolean).map(function (term) {
      return /[*"]$/.test(term) ? term : term + '*';
    }).join(' ');
    return SEARCH_URL + '?q=' + encodeURIComponent(wildcard || q) + '&type=' + FULL_SEARCH_TYPES;
  }

  /* Il link «tutti i risultati» (tappa 1b, critico media 4; mappa della parte 1
     §4.4.3: «va fatto vedere sempre»). Sta in fondo al pannello, fuori dalla
     parte che scorre, e si vede con qualunque parola scritta, anche quando
     l'indice locale non trova prodotti: porta dove porta Enter. Niente numero
     nella scritta (zg.search.view_all, non view_all_results): il pannello
     conosce solo i prodotti dell'indice locale e le prime 5 pagine del
     predittivo, non il conto della ricerca completa, e un numero diverso da
     quello della pagina d'arrivo sarebbe falso. Col pannello vuoto il link
     non c'e'. */
  function allLink() {
    var foot = document.getElementById('lsFoot');
    if (foot) return foot;
    var body = document.getElementById('lsBody');
    if (!body || !body.parentNode) return null;
    foot = document.createElement('div');
    foot.className = 'ls-foot';
    foot.id = 'lsFoot';
    foot.hidden = true;
    foot.innerHTML = '<a class="ls-all" href="' + esc(SEARCH_URL) + '" data-ls-navigate>' +
      '<span class="ls-all__t">' + esc(t('searchViewAll', 'View all results')) + '</span>' +
      '<svg class="ls-all__arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14"/><polyline points="13 6 19 12 13 18"/></svg>' +
      '</a>';
    body.parentNode.insertBefore(foot, body.nextSibling);
    return foot;
  }

  function showAllLink(q) {
    var foot = allLink();
    if (!foot) return;
    var link = foot.querySelector('.ls-all');
    link.href = resultsUrl(q);
    link.setAttribute('data-ls-query', q);
    foot.hidden = false;
  }

  function hideAllLink() {
    var foot = document.getElementById('lsFoot');
    if (foot) foot.hidden = true;
  }

  function getResultCache(q) {
    try {
      var raw = sessionStorage.getItem(RESULT_CACHE_PREFIX + q.toLowerCase());
      if (!raw) return null;
      var cached = JSON.parse(raw);
      if (Date.now() - cached.ts > CACHE_TTL) {
        sessionStorage.removeItem(RESULT_CACHE_PREFIX + q.toLowerCase());
        return null;
      }
      return cached.results;
    } catch (e) {
      return null;
    }
  }

  function setResultCache(q, results) {
    try {
      sessionStorage.setItem(RESULT_CACHE_PREFIX + q.toLowerCase(), JSON.stringify({ ts: Date.now(), results: results }));
    } catch (e) {}
  }

  function wordStart(text, query) {
    if (!text || !query) return false;
    return text.indexOf(query) === 0 || text.indexOf(' ' + query) !== -1;
  }

  function productScore(product, query, tokens) {
    var score = 0;
    if (product.titleText === query) score += 130;
    if (product.handleText === query) score += 120;
    // +90 (regola definitiva del 02/09): la query e prefisso del nome mostrato
    // OPPURE comincia a un confine di parola nel sottotitolo — «orange» prende
    // «sicilian blood orange soda», non una sottostringa dentro una parola.
    // Max, non somma: un prodotto non prende +180. Il +70 sotto resta sul
    // titolo intero.
    if (product.nameText.indexOf(query) === 0 || wordStart(product.subText, query)) score += 90;
    if (product.titleText.indexOf(query) !== -1) score += 70;
    if (product.handleText.indexOf(query) !== -1) score += 45;
    if (product.vendorText.indexOf(query) !== -1) score += 35;
    if (product.categoryText.indexOf(query) !== -1) score += 30;

    tokens.forEach(function (token) {
      if (!token) return;
      if (product.titleText.indexOf(token) !== -1) score += 28;
      if (product.titleText.split(' ').some(function (word) { return word.indexOf(token) === 0; })) score += 18;
      if (product.searchText.indexOf(token) !== -1) score += 14;
      if (product.vendorText.indexOf(token) !== -1) score += 10;
      if (product.categoryText.indexOf(token) !== -1) score += 10;
    });

    return score;
  }

  function tokenMatchesProduct(product, token) {
    if (!token) return true;
    if (token.length <= 1) return product.searchText.indexOf(token) !== -1;
    if (product.searchText.indexOf(token) !== -1) return true;
    return product.searchText.split(' ').some(function (word) {
      return word.indexOf(token) === 0;
    });
  }

  function searchCatalog(q) {
    var query = normalizeText(q);
    var tokens = query.split(' ').filter(Boolean);
    if (!query || !tokens.length) return { products: [], productTotal: 0, queries: [] };

    var scored = catalogProducts.map(function (product, index) {
      return { product: product, index: index, score: productScore(product, query, tokens) };
    }).filter(function (item) {
      return item.score > 0 && tokens.every(function (token) { return tokenMatchesProduct(item.product, token); });
    }).sort(function (a, b) {
      if (b.score !== a.score) return b.score - a.score;
      return a.index - b.index;
    });

    var products = scored.slice(0, 12).map(function (item) { return item.product; });
    return {
      products: products,
      productTotal: scored.length,
      queries: buildQuerySuggestions(q, products)
    };
  }

  function buildQuerySuggestions(q, products) {
    var query = normalizeText(q);
    var seen = {};
    var suggestions = [];
    function add(text) {
      text = String(text || '').trim();
      var key = normalizeText(text);
      if (!text || !key || key === query || seen[key]) return;
      seen[key] = true;
      suggestions.push({ text: text });
    }
    /* 8c (02/09): ordine per TIPO, non per prodotto — prima i nomi dei prodotti
       trovati, poi i produttori, poi le categorie (una voce per etichetta: una
       categoria doppia da due voci, mai «A / B»), poi le query di Shopify che
       suggest() accoda. Prima usciva «Pistachio & Almond / Biscuits & Sweets»
       per «orange», perche i Biscottini Arancia e Manna stanno in due
       categorie e la loro etichetta seguiva subito il loro nome. */
    var names = [], vendors = [], cats = [];
    products.slice(0, 8).forEach(function (product) {
      names.push(product.title);
      vendors.push(product.vendor);
      String(product.categoryLabel || '').split(' / ').forEach(function (c) { cats.push(c); });
    });
    names.forEach(add);
    vendors.forEach(add);
    cats.forEach(add);
    CATEGORY_TERMS.forEach(function (term) {
      if (normalizeText(term).indexOf(query) !== -1 || query.indexOf(normalizeText(term)) !== -1) add(term);
    });
    if (!suggestions.length && q) add(q);
    return suggestions.slice(0, 7);
  }

  /* complete: la risposta vale per la cache dei risultati (anche «niente
     predittivo in questa lingua»); false dopo un 429, un errore o la rete
     caduta, cosi' la stessa ricerca riprova invece di restare senza pagine
     per i 10 minuti della cache. */
  function noInfo(complete) {
    return { pages: [], articles: [], queries: [], complete: complete };
  }

  function searchInfo(q) {
    if (!predictiveOn) return Promise.resolve(noInfo(true));
    if (Date.now() < predictivePauseUntil) return Promise.resolve(noInfo(false));
    /* Lingua non ancora confermata e una richiesta gia' in volo: si aspetta
       la sua risposta, poi si riprova solo se la parola e' ancora quella
       scritta (un 417 nel frattempo spegne tutto senza altre richieste). */
    if (!predictiveConfirmed && predictiveProbe) {
      return predictiveProbe.then(function () {
        return q === currentQuery ? searchInfo(q) : noInfo(false);
      });
    }
    var request = fetch(PREDICTIVE_URL + '?q=' + encodeURIComponent(q) + '&resources[type]=' + PREDICTIVE_TYPES + '&resources[limit]=5')
      .then(function (response) {
        if (response.status === 417) {
          predictiveOn = false;
          try { sessionStorage.setItem(PREDICTIVE_OFF_KEY, '1'); } catch (e) {}
          return noInfo(true);
        }
        if (response.status === 429) {
          var wait = parseInt(response.headers.get('Retry-After'), 10);
          predictivePauseUntil = Date.now() + (wait > 0 ? Math.min(wait, 60) : 2) * 1000;
          return noInfo(false);
        }
        if (!response.ok) return noInfo(false);
        return response.json().then(function (data) {
          var results = data && data.resources && data.resources.results;
          predictiveConfirmed = true;
          return {
            pages: (results && results.pages) || [],
            articles: (results && results.articles) || [],
            queries: (results && results.queries) || [],
            complete: true
          };
        });
      })
      .catch(function () { return noInfo(false); });
    if (!predictiveConfirmed) {
      predictiveProbe = request;
      request.then(function () { if (predictiveProbe === request) predictiveProbe = null; });
    }
    return request;
  }

  function suggest(q, cb) {
    if (!q.trim()) return cb({ products: [], pages: [], articles: [], queries: [], productTotal: 0 });
    var hit = getResultCache(q);
    if (hit) return cb(hit);

    loadCatalog()
      .then(function () {
        var local = searchCatalog(q);
        var immediate = {
          products: local.products,
          productTotal: local.productTotal,
          pages: [],
          articles: [],
          queries: local.queries
        };
        cb(immediate);
        return searchInfo(q).then(function (info) {
          var merged = {
            products: local.products,
            productTotal: local.productTotal,
            pages: info.pages,
            articles: info.articles,
            queries: local.queries.concat((info.queries || []).map(function (item) { return { text: item.text || item }; })).slice(0, 8)
          };
          if (info.complete) setResultCache(q, merged);
          // Senza niente in piu' dal predittivo la lista e' gia' quella
          // mostrata da cb(immediate): niente secondo giro di dissolvenza.
          var added = info.pages.length + info.articles.length + info.queries.length;
          if (q === currentQuery && added) renderResults(q, merged);
          return merged;
        });
      })
      .catch(function () { cb({ products: [], pages: [], articles: [], queries: [], productTotal: 0 }); });
  }

  function highlight(text, q) {
    if (!q) return esc(text);
    var tokens = normalizeText(q).split(' ').filter(Boolean).map(function (token) {
      return token.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    });
    if (!tokens.length) return esc(text);
    // Match on the RAW string and escape each segment afterwards, so
    // tokens can never bite into HTML entities (e.g. 'am' in '&amp;')
    // or into previously injected <mark> markup.
    var re = new RegExp('(' + tokens.join('|') + ')', 'ig');
    return String(text == null ? '' : text).split(re).map(function (part, index) {
      return index % 2 === 1 ? '<mark class="ls-mark">' + esc(part) + '</mark>' : esc(part);
    }).join('');
  }

  var bloccata = false;
  function open() {
    if (isOpen) return;
    isOpen = true;
    var overlay = document.getElementById('lsOverlay');
    if (!overlay) return;
    overlay.removeAttribute('hidden');
    void overlay.offsetWidth;
    overlay.classList.add('is-open');
    if (window.zgFocusTrap) window.zgFocusTrap.on(overlay);
    document.body.classList.add('search-overlay-open');
    /* Foglio 07 §2 (f07-rotella): anche la ricerca prende il blocco condiviso (ferma Lenis; al tocco la guardia del dito e
       la posizione ripresa alla chiusura). La rotella era gia' a posto: tutto il pannello ha data-lenis-prevent e la classe
       qui sopra mette overflow: hidden, che resta. bloccata tiene on/off in pari. */
    if (window.zgScrollLock && !bloccata) { bloccata = true; zgScrollLock.on(); }
    searchToggles().forEach(function (toggle) {
      toggle.classList.add('is-active');
      toggle.setAttribute('aria-expanded', 'true');
    });
    var input = document.getElementById('lsInput');
    if (input) {
      input.value = currentQuery;
      setTimeout(function () { input.focus(); }, 60);
    }
    loadCatalog().then(function () {
      if (currentQuery) triggerSearch(currentQuery);
      else renderEmpty();
    });
    if (currentQuery) triggerSearch(currentQuery);
    else renderEmpty();
  }

  function close(resetQuery) {
    if (!isOpen) return;
    isOpen = false;
    var overlay = document.getElementById('lsOverlay');
    if (window.zgFocusTrap && overlay) window.zgFocusTrap.off(overlay);
    if (overlay) {
      overlay.classList.remove('is-open');
      overlay.classList.add('is-closing');
      setTimeout(function () {
        if (overlay) {
          overlay.classList.remove('is-closing');
          overlay.setAttribute('hidden', '');
        }
      }, 260);
    }
    document.body.classList.remove('search-overlay-open');
    if (bloccata) { bloccata = false; zgScrollLock.off(); }
    searchToggles().forEach(function (toggle) {
      toggle.classList.remove('is-active');
      toggle.setAttribute('aria-expanded', 'false');
    });
    if (resetQuery) {
      currentQuery = '';
      var input = document.getElementById('lsInput');
      if (input) input.value = '';
    }
    setTimeout(function () {
      var searchToggle = visibleSearchToggle();
      if (searchToggle) searchToggle.focus();
    }, 100);
  }

  function triggerSearch(q) {
    currentQuery = q;
    clearTimeout(debounceTimer);
    clearTimeout(loadingTimer);
    var spinner = document.getElementById('lsSpinner');
    if (!q.trim()) {
      if (spinner) spinner.style.display = 'none';
      renderEmpty();
      return;
    }
    debounceTimer = setTimeout(function () {
      loadingTimer = setTimeout(function () { if (spinner) spinner.style.display = ''; }, 220);
      suggest(q, function (results) {
        clearTimeout(loadingTimer);
        if (spinner) spinner.style.display = 'none';
        if (q !== currentQuery) return;
        renderResults(q, results);
      });
    }, DEBOUNCE_MS);
  }

  function renderEmpty() {
    var body = document.getElementById('lsBody');
    if (!body) return;
    var html = '';

    if (recentSearches.length > 0) {
      html += '<div class="ls-sec ls-sec--recent" style="--delay:100ms">' +
        '<div class="ls-sec__head">' +
          '<p class="ls-sec__title">' + (I18N.recentSearches || 'Recent searches') + '</p>' +
          '<button class="ls-sec__clear" data-clear-recent>' + (I18N.clear || 'Clear') + '</button>' +
        '</div><div class="ls-pills">';
      recentSearches.slice(0, 8).forEach(function (item) {
        html += '<button class="ls-pill ls-pill--recent" data-recent-q="' + esc(item.q) + '">' +
          esc(item.q) + '<span class="ls-pill__x" data-remove-recent="' + esc(item.q) + '" aria-label="' + esc(I18N.remove || 'Remove') + '" role="button">x</span></button>';
      });
      html += '</div></div>';
    }

    html += '<div class="ls-sec ls-sec--popular" style="--delay:150ms">' +
      '<p class="ls-sec__title">' + esc(t('searchCollectionFilters', 'Collection filters')) + '</p><div class="ls-pills">';
    CATEGORY_TERMS.forEach(function (term, index) {
      html += '<button class="ls-pill ls-pill--pop" data-popular-q="' + esc(term) + '" style="--pi:' + index + '">' + esc(term) + '</button>';
    });
    html += '</div></div>';

    if (trendingProducts.length > 0) {
      html += '<div class="ls-sec ls-sec--trend" style="--delay:200ms">' +
        '<p class="ls-sec__title">' + esc(t('searchCatalog', 'Selections catalog')) + '</p><div class="ls-trend-grid">';
      trendingProducts.slice(0, 6).forEach(function (product, index) {
        var src = product.image ? esc(product.image.split('?')[0] + '?width=320') : '';
        var imgEl = src ? '<img src="' + src + '" alt="' + esc(product.title) + '" loading="lazy">' : '<div class="ls-card__ph"></div>';
        html += '<a href="' + esc(product.url) + '" class="ls-trend-card" data-ls-navigate style="--pi:' + index + '">' +
          '<div class="ls-trend-card__media">' + imgEl + '</div>' +
          '<p class="ls-trend-card__name">' + esc(product.title) + '</p>' +
          (product.subtitle ? '<p class="col-card__subtitle">' + esc(product.subtitle) + '</p>' : '') +
          '<p class="ls-trend-card__type">' + esc(product.categoryLabel || product.vendor) + '</p>' +
        '</a>';
      });
      html += '</div></div>';
    }

    body.innerHTML = html;
    hideAllLink();
    requestAnimationFrame(function () {
      body.querySelectorAll('.ls-sec').forEach(function (section) { section.classList.add('is-visible'); });
      body.querySelectorAll('.ls-pill--pop').forEach(function (pill) { pill.classList.add('is-visible'); });
      body.querySelectorAll('.ls-trend-card').forEach(function (card) { card.classList.add('is-visible'); });
    });
    var live = document.getElementById('lsLive');
    if (live) live.textContent = '';
  }

  function renderResults(q, results) {
    var body = document.getElementById('lsBody');
    if (!body) return;
    var products = results.products || [];
    var queries = results.queries || [];
    var pages = results.pages || [];
    var articles = results.articles || [];
    var count = results.productTotal || products.length;

    showAllLink(q);
    body.classList.add('is-transitioning');
    setTimeout(function () {
      body.innerHTML = buildResultsHTML(q, queries, products, pages, articles);
      body.classList.remove('is-transitioning');
      body.classList.add('is-entering');
      requestAnimationFrame(function () {
        body.classList.remove('is-entering');
        body.querySelectorAll('.ls-prod-card').forEach(function (card, index) {
          card.style.setProperty('--pi', String(index));
          card.classList.add('is-visible');
        });
      });
    }, 180);

    var live = document.getElementById('lsLive');
    if (live) {
      live.textContent = count === 1
        ? t('selectionFoundOne', '1 selection found')
        : t('selectionFoundOther', '%COUNT% selections found').replace('%COUNT%', String(count));
    }
  }

  function buildResultsHTML(q, queries, products, pages, articles) {
    pages = pages || [];
    articles = articles || [];
    var leftHTML = '<div class="ls-results__col ls-results__col--left"><p class="ls-sec__title">' + esc(t('searchSuggestions', 'Search suggestions')) + '</p>';

    if (!queries.length) {
      leftHTML += '<p class="ls-no-hint">' + esc(t('searchTryDifferent', 'Try a different term')) + '</p>';
    } else {
      leftHTML += '<ul class="ls-sugg-list" role="listbox" aria-label="' + esc(t('searchSuggestions', 'Search suggestions')) + '">';
      /* sotto i 768 al massimo 4 voci (8c): a 390 le tile cominciavano a y 612 */
      var maxQueries = window.matchMedia('(max-width: 767.98px)').matches ? 4 : 8;
      queries.slice(0, maxQueries).forEach(function (item) {
        var text = item.text || item;
        leftHTML += '<li class="ls-sugg-item" role="option" aria-selected="false" tabindex="-1" data-sugg-q="' + esc(text) + '">' +
          '<svg class="ls-sugg__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="m16.5 16.5 4 4"/></svg>' +
          '<span class="ls-sugg__text">' + highlight(text, q) + '</span>' +
          '<svg class="ls-sugg__chevron" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" aria-hidden="true"><polyline points="9 18 15 12 9 6"/></svg>' +
        '</li>';
      });
      leftHTML += '</ul>';
    }

    var info = pages.concat(articles);
    if (info.length) {
      leftHTML += '<p class="ls-sec__title ls-sec__title--sub">' + esc(I18N.searchPagesGuides || 'Pages & guides') + '</p><ul class="ls-info-list">';
      info.forEach(function (item) {
        var sub = (item.body || item.summary_html || item.content || '').replace(/<[^>]*>/g, '').trim();
        if (sub.length > 90) sub = sub.slice(0, 90).replace(/\s+\S*$/, '') + '...';
        leftHTML += '<li><a href="' + esc(item.url) + '" class="ls-info-item" data-ls-navigate data-ls-query="' + esc(q) + '">' +
          '<svg class="ls-info-item__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M14 3H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"/><polyline points="14 3 14 9 20 9"/></svg>' +
          '<span class="ls-info-item__text"><span class="ls-info-item__title">' + highlight(item.title, q) + '</span>' +
          (sub ? '<span class="ls-info-item__sub">' + esc(sub) + '</span>' : '') + '</span>' +
          '<svg class="ls-sugg__chevron" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" aria-hidden="true"><polyline points="9 18 15 12 9 6"/></svg>' +
        '</a></li>';
      });
      leftHTML += '</ul>';
    }
    leftHTML += '</div>';

    var rightHTML = '<div class="ls-results__col ls-results__col--right"><p class="ls-sec__title">' + esc(t('searchCatalog', 'Selections catalog')) + '</p>';
    if (!products.length) {
      rightHTML += '<p class="ls-no-results">' + esc(t('searchNoSelections', 'No selections found.')) + '<br><span>' + esc(t('searchNoSelectionsHint', 'Try a product name, producer, or collection filter.')) + '</span></p>';
    } else {
      rightHTML += '<div class="ls-prod-grid">';
      products.forEach(function (product) {
        var src = product.image ? esc(product.image.split('?')[0] + '?width=400') : '';
        var imgEl = src ? '<img src="' + src + '" alt="' + esc(product.title) + '" loading="lazy">' : '<div class="ls-card__ph"></div>';
        rightHTML += '<a href="' + esc(product.url) + '" class="ls-prod-card" data-ls-navigate data-ls-query="' + esc(q) + '">' +
          '<div class="ls-prod-card__media">' + imgEl + '</div>' +
          '<p class="ls-prod-card__name">' + highlight(product.title, q) + '</p>' +
          (product.subtitle ? '<p class="col-card__subtitle">' + highlight(product.subtitle, q) + '</p>' : '') +
          '<p class="ls-prod-card__price">' + esc(product.price) + (product.available ? '' : ' - ' + esc(product.availabilityLabel)) + '</p>' +
          '<p class="ls-prod-card__type">' + esc(product.categoryLabel || product.vendor) + '</p>' +
        '</a>';
      });
      rightHTML += '</div>';
    }
    rightHTML += '</div>';

    return '<div class="ls-results">' + leftHTML + rightHTML + '</div>';
  }

  function moveFocus(dir) {
    var items = Array.from(document.querySelectorAll('.ls-sugg-item'));
    if (!items.length) return;
    items.forEach(function (item) { item.setAttribute('aria-selected', 'false'); });
    focusedIdx = Math.max(-1, Math.min(items.length - 1, focusedIdx + dir));
    if (focusedIdx >= 0) {
      items[focusedIdx].setAttribute('aria-selected', 'true');
      items[focusedIdx].focus();
    } else {
      var input = document.getElementById('lsInput');
      if (input) input.focus();
    }
  }

  function prefetch(href) {
    if (!href || document.querySelector('link[rel="prefetch"][href="' + href + '"]')) return;
    var link = document.createElement('link');
    link.rel = 'prefetch';
    link.href = href;
    document.head.appendChild(link);
  }

  function init() {
    loadRecent();
    loadCatalog().then(function () {
      if (isOpen && !currentQuery) renderEmpty();
    });

    searchToggles().forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        if (isOpen) close(true);
        else open();
      });
    });

    var input = document.getElementById('lsInput');
    if (input) {
      input.addEventListener('input', function () {
        focusedIdx = -1;
        triggerSearch(input.value);
      });
      input.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') { close(true); return; }
        if (event.key === 'ArrowDown') { event.preventDefault(); moveFocus(1); return; }
        if (event.key === 'ArrowUp') { event.preventDefault(); moveFocus(-1); return; }
        if (event.key === 'Enter') {
          event.preventDefault();
          var v = input.value.trim();
          if (v) {
            addToRecent(v);
            window.location.href = resultsUrl(v);
          }
        }
      });
    }

    document.addEventListener('click', function (event) {
      if (event.target.closest('[data-ls-close]')) close(true);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && isOpen) { close(true); return; }
      if ((event.metaKey || event.ctrlKey) && event.key === 'k') {
        event.preventDefault();
        if (isOpen) close(true);
        else open();
      }
    });

    document.addEventListener('click', function (event) {
      if (event.target.closest('[data-remove-recent]')) return;
      var pill = event.target.closest('[data-recent-q]');
      if (!pill) return;
      var q = pill.dataset.recentQ;
      var inputEl = document.getElementById('lsInput');
      if (inputEl) inputEl.value = q;
      triggerSearch(q);
    });

    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-remove-recent]');
      if (!button) return;
      event.stopPropagation();
      removeFromRecent(button.dataset.removeRecent);
      renderEmpty();
    });

    document.addEventListener('click', function (event) {
      if (!event.target.closest('[data-clear-recent]')) return;
      recentSearches = [];
      saveRecent();
      renderEmpty();
    });

    document.addEventListener('click', function (event) {
      var pill = event.target.closest('[data-popular-q]');
      if (!pill) return;
      var q = pill.dataset.popularQ;
      var inputEl = document.getElementById('lsInput');
      if (inputEl) inputEl.value = q;
      triggerSearch(q);
    });

    document.addEventListener('click', function (event) {
      var item = event.target.closest('[data-sugg-q]');
      if (!item) return;
      var q = item.dataset.suggQ;
      var inputEl = document.getElementById('lsInput');
      if (inputEl) inputEl.value = q;
      triggerSearch(q);
    });

    document.addEventListener('keydown', function (event) {
      var item = document.activeElement && document.activeElement.closest('[data-sugg-q]');
      if (!item) return;
      if (event.key === 'Enter') {
        var q = item.dataset.suggQ;
        var inputEl = document.getElementById('lsInput');
        if (inputEl) {
          inputEl.value = q;
          inputEl.focus();
        }
        triggerSearch(q);
      }
      if (event.key === 'ArrowDown') { event.preventDefault(); moveFocus(1); }
      if (event.key === 'ArrowUp') { event.preventDefault(); moveFocus(-1); }
    });

    document.addEventListener('click', function (event) {
      var link = event.target.closest('[data-ls-navigate]');
      if (!link) return;
      var q = link.dataset.lsQuery || currentQuery;
      if (q) addToRecent(q);
      close(false);
    });

    document.addEventListener('mouseover', function (event) {
      var link = event.target.closest('.ls-prod-card, .ls-trend-card');
      if (!link || !link.href) return;
      clearTimeout(prefetchTimer);
      prefetchTimer = setTimeout(function () { prefetch(link.href); }, 300);
    });

    document.addEventListener('mouseout', function (event) {
      if (event.target.closest('.ls-prod-card, .ls-trend-card')) clearTimeout(prefetchTimer);
    });

    window.addEventListener('storage', function (event) {
      if (event.key !== 'zagara_search_ts') return;
      loadRecent();
      if (isOpen && !currentQuery) renderEmpty();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.zagaraSearch = { open: open, close: close };
})();
